import { ComponentStyleProps } from "../../../lib/styles/props/component-style-props";
import React, { ReactElement, useCallback } from "react";
import { FiCalendar } from "react-icons/fi";
import {
  ComponentSingleStyleConfig,
  HStack,
  useStyleConfig,
} from "@chakra-ui/react";
import { CMDatePicker } from "../CMDatePicker/CMDatePicker";
import { CMTimePicker } from "../CMTimePicker/CMTimePicker";
import { DatetimeValuePartial } from "../../../lib";

export type CMDatetimePickerProps = {
  datePlaceholder?: string;
  timePlaceholder?: string;

  dateIcon?: ReactElement;

  selected?: DatetimeValuePartial | null;

  minDate?: {
    year: number;
    month: number;
    day: number;
  };
  maxDate?: {
    year: number;
    month: number;
    day: number;
  };

  onChange?: (value: DatetimeValuePartial) => void;
} & ComponentStyleProps;
export const CMDatetimePicker = ({
  datePlaceholder,
  timePlaceholder,

  dateIcon = <FiCalendar />,

  selected = null,

  minDate,
  maxDate,

  onChange,

  sx,

  ...rest
}: CMDatetimePickerProps) => {
  const styles = useStyleConfig("CMDatetimePickerStyles");

  const handleChangeDate = useCallback(
    (
      value: {
        year: number;
        month: number;
        day: number;
      } | null,
    ) => {
      onChange?.({ date: value ?? undefined, time: selected?.time });
    },
    [onChange, selected?.time],
  );
  const handleChangeTime = useCallback(
    (value: { hour: number; minute: number } | null) => {
      onChange?.({ date: selected?.date, time: value ?? undefined });
    },
    [onChange, selected?.date],
  );

  return (
    <HStack sx={{ ...styles, ...sx }} {...rest}>
      <CMDatePicker
        placeholder={datePlaceholder}
        icon={dateIcon}
        selected={selected?.date}
        minDate={minDate}
        maxDate={maxDate}
        onChange={handleChangeDate}
        sx={{ flex: "1 1 auto" }}
      />
      <CMTimePicker
        placeholder={timePlaceholder}
        selected={selected?.time}
        onChange={handleChangeTime}
        sx={{ flex: "0 0 120px" }}
      />
    </HStack>
  );
};
export const CMDatetimePickerStyles: ComponentSingleStyleConfig = {
  baseStyle: {},
};
